module.exports = __webpack_public_path__ + "static/img/2_01.6fb05414.jpg";